import React from "react";
import AppRouter from "./routes/AppRouter";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Layout from "./layouts/Layout";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Layout>
          <AppRouter />
        </Layout>
        <CookieConsent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
